import { useEffect, useState } from "react";
// hooks
import { useLanding } from "../../../hooks/useLanding";
import { usePersonaNatural } from "../../../hooks/usePersonaNatural";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../components/BannerPanel";
import { MenuUsuario } from "../components/MenuUsuario";
import { Cards } from "../../Landing/components/Cards/cards";
import { Buttonloadmore } from "../../../components/Landing/Buttonloadmore";
import { Footer } from "../../../components/Landing/Footer";
//  styled components
import { AlternadorVista } from "../../../components/Generales/AlternadorVista";
import { CampoDeBusqueda } from "../../../components/Generales/CampoDeBusqueda";
import { Table, Empty } from "antd";
// select data
import { useNavigate } from "react-router-dom";
import apiMaestras from "../../../api/Maestras/api-maestras";
import {
  ANCHO_TABLA_CONVOCATORIA,
  obtenerColumnsTablaConvocatoria,
} from "../../../utils/tablaConvocatoriaHelper";
import { coloresEstado } from "../../../constants/common";

export const BuscarConvocatoria = () => {
  // states
  const { cargarInformacionParticipante } = usePersonaNatural();
  const {
    principalState,
    setPrincipalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    limipiarfiltros,
    buscarconvocatorias,
    buscarPorTexto,
    visibleButton,
    loadingConvocatorias,
  } = useLanding();




  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      cargarInformacionParticipante();
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);

  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  useEffect(() => {
    getLineasConvocatorias();
  }, []);

  const getLineasConvocatorias = async () => {
    try {
      const data = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatorias(Array.isArray(data) ? data : (data?.data || []));
    } catch (error) {
      setLineasConvocatorias([]);
    }
  };

  // Se entra viendo la tabla: compara de un vistazo y cabe mas en pantalla.
  const [mostrarTabla, setMostrarTabla] = useState(true);
  const datosTabla = principalState.convocatoriasslice
    .filter((data: any) => data.entidad !== "AGENDA CULTURAL")
    .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
    .map((data: any) => ({
      idconvocatorias: data.idconvocatorias,
      nombre_convocatoria: data.nombre_convocatoria,
      portada_url: data.portada_url,
      fechas: data.fechas,
      estado: data.estado,
      entidad: data.entidad,
      linea_convocatoria: data.linea_convocatoria,
      tipo_participante: data.tipo_participante,
      area: data.area,
    }));

  const columns = obtenerColumnsTablaConvocatoria(LineasConvocatorias, coloresEstado, false);

  const handleRowClick = (record: any) => {
    window["scrollTo"]({ top: 0, behavior: "smooth" });
    navigate(`/verconvocatoria/${record.idconvocatorias}`);
  };

  return (
    <div>
      <Header />
      <div className="container-fluid2" style={{ paddingTop: "1.5%", paddingBottom: "5%" }}>
        <div className="row">
          <MenuUsuario activeItem={2} />
          <div className="col-12 col-md-12 col-lg-10">
            <div className="row">
              <div className="justify-content-center">
                <div className="container-titles-information-component">
                  <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
                    <span className="font-family-Montserrat-Bold">Buscar </span>convocatorias
                  </div>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-12 col-md-3">
                <AlternadorVista mostrarTabla={mostrarTabla} alCambiar={setMostrarTabla} />
              </div>
              <div className="col-12 col-md-6">
                <CampoDeBusqueda
                  textoInicial={principalState.buscarconvocatorias.buscar_palabra_clave ?? ""}
                  alBuscar={buscarPorTexto}
                />
              </div>
              {/* Vacia: es lo que deja el buscador centrado en la fila. */}
              <div className="d-none d-md-block col-md-3" />
            </div>
            {mostrarTabla ? (
              <div className="row">
                <div className="col-12">
                  <Table
                    style={{ borderTop: "1px solid #C4C4C4", fontSize: "16px" }}
                    locale={{
                      emptyText: (
                        <Empty
                          description="No hay información para mostrar"
                          style={{ padding: "50px" }}
                        />
                      ),
                    }}
                    pagination={false}
                    scroll={{ x: ANCHO_TABLA_CONVOCATORIA }}
                    columns={columns}
                    dataSource={datosTabla}
                    size="middle"
                    bordered={false}
                    loading={loadingConvocatorias}
                    onRow={(record) => {
                      return {
                        onClick: () => handleRowClick(record),
                        style: {
                          cursor: "pointer",
                        },
                      };
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="row">
                {[...principalState.convocatoriasslice]
                  .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
                  .filter((data: any) => data.entidad !== "AGENDA CULTURAL")
                  .map((data: any) => (
                    <div key={`contenedor_${data.idconvocatorias}`} className="col-12 col-md-3">
                      <Cards key={data.idconvocatorias} convocatorias={data} />
                    </div>
                  ))}
              </div>
            )}
            {visibleButton && <Buttonloadmore doFunction={() => getSiguientesConvocatorias()} />}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
